import { ImporterRun } from 'dashboard/models/importer-run';
import { ImporterRunsActions, ImporterRunsActionType } from 'dashboard/redux/actions/importer-runs';

export interface ImporterRunState {
  importerRun: ImporterRun;
}

const initialState: ImporterRunState = {
  importerRun: {} as ImporterRun,
};

export default (state: ImporterRunState = initialState, action: ImporterRunsActions) => {
  if (!action || !action.type || !action.payload) {
    return state;
  }
  switch (action.type) {
    case ImporterRunsActionType.SaveImporterRun: {
      return {
        ...state,
        importerRun: action.payload.importerRun,
      };
    }
    default:
      return state;
  }
};
